import { useState, useMemo } from "react";
import { GoogleMap, useLoadScript, Marker } from "@react-google-maps/api";
import usePlacesAutocomplete, {
  getGeocode,
  getLatLng,
} from "use-places-autocomplete"; // Import the usePlacesAutocomplete hook
import {
  Combobox,
  ComboboxInput,
  ComboboxPopover,
  ComboboxList,
  ComboboxOption,
} from "@reach/combobox";
import "@reach/combobox/styles.css"; // Import the styles for the combobox


export default function Places() {
  const { isLoaded } = useLoadScript({
    googleMapsApiKey: "AIzaSyAkNlfsORaXNSKBPojNkDhHNvVCtdsT3IU",
    libraries: ["places"],
  });

  if (!isLoaded) return <div>Loading...</div>;
  return <Map />;
}

function Map(props) {
  const center = useMemo(
    () => ({ lat: 40.781429682788385, lng: -73.97362342255302 }),
    []
  );
  const [selected, setSelected] = useState(null);
 
  

  return (
    <>
      <div className="places-container">
        <PlacesAutocomplete setSelected={setSelected} />
      </div>

      <GoogleMap
        zoom={10}
        center={center}
        mapContainerClassName="map-container"
      >
        {selected && <Marker position={selected} />}

        <Marker
          title={"Parking Spot 2"}
          name={"Parking Spot 2"}
          position={{ lat: 40.748, lng: -73.938 }} // Set marker position for spot 2
        />
      </GoogleMap>
   
      {/* <Sidebar /> */}
    </>
  );
}

const PlacesAutocomplete = ({ setSelected }) => {
  const {
    ready,
    value,
    setValue,
    suggestions: { status, data },
    clearSuggestions,
  } = usePlacesAutocomplete();

  const handleSelect = async (address) => {
    setValue(address, false);
    clearSuggestions();

    const results = await getGeocode({ address });
    const { lat, lng } = await getLatLng(results[0]);
    setSelected({ lat, lng });
  };
  return (
    <Combobox onSelect={handleSelect}>
      <ComboboxInput
        value={value}
        onChange={(e) => setValue(e.target.value)}
          disabled={!ready}
          className="places-input"
          placeholder="Enter an address"
         />
         <ComboboxPopover>
                <ComboboxList>
                    {status === "OK" &&
                    data.map(({ place_id, description }) => (
                        <ComboboxOption key={place_id} value={description} />
                      ))}
                </ComboboxList>
            </ComboboxPopover> 
  
      </Combobox>
  );
  
};
